import React, { useEffect, useRef, useState } from 'react';
import SlideRightDialog from '../../components/common/SlideRightDialog';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const PDFViewer = ({ file }) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!file) return;

    const renderPDF = async () => {
      try {
        setLoading(true);
        const container = containerRef.current;
        container.innerHTML = '';

        const pdf = await pdfjsLib.getDocument(file).promise;
        const numPages = pdf.numPages;

        for (let pageNum = 1; pageNum <= numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1.5 });

          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          canvas.style.display = 'block';
          canvas.style.marginBottom = '10px';
          canvas.style.maxWidth = '100%';
          canvas.style.height = 'auto';

          container.appendChild(canvas);

          await page.render({
            canvasContext: context,
            viewport: viewport,
          }).promise;
        }

        setLoading(false);
      } catch (error) {
        console.error('PDF 렌더링 실패:', error);
        setLoading(false);
      }
    };

    renderPDF();
  }, [file]);

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'auto', padding: '10px' }}>
      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>로딩중...</div>
      )}
      <div ref={containerRef} style={{ width: '100%' }} />
    </div>
  );
};

const Viewer = ({ isOpen, onClose, file, fileType = '' }) => {
  const isPDF = fileType === 'pdf';

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose}>
      {isPDF ? (
        <PDFViewer file={file} />
      ) : (
        <img
          src={file}
          alt="증빙서류"
          style={{ border: 'none', maxWidth: '100%', maxHeight: '100%' }}
        />
      )}
    </SlideRightDialog>
  );
};

export default Viewer;
